// extracted by mini-css-extract-plugin
export var cartIcon = "_kk-0";
export var cartIconContainer = "_kk-1";